import React, { useState, useEffect } from "react";

//Importar dependencias para el acordeón de Material UI.
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

//Importar helpers.
import useDragAndDrop from "../../../../../hooks/useDragAndDrop.js";
import { handleDropFile } from "../../../../../helpers/multimedia/handleDropFile.js";
import { verifyCondition_draggingView } from "../../../../../const/conditionalConstants/draggingViewRender.js";

//Importar componenetes locales.
import MessageInChat from "../Messages/MessageInChat.jsx";
import Draggingview from "../Components/Draggingview.jsx";
import SessionHeader from "./SessionHeader.jsx";
import { verifyCondition_sessionHeight } from "../../../../../const/conditionalConstants/sessionHeightByStatus.js";

// Session: Componente que renderiza la sesion del chat seleccionado (todos los mensajes de la sesion).

const Session = ({ filesSelected, chatData, sessions, setFilesSelected, session, onSelectedSession, sessionSelected, setTypeFile, containerRefHeight, setSessionExpanded, setOpenMessageFileSize }) => {
    const [sessionContainerHeight, setSessionContainerHeight] = useState({ height: "698" });
    const [expanded, setExpanded] = useState(false); //Estado para actualizar el cerrar y abrir del acordeón de las sesiones.
    const onHandleDrop = (files) => { //Función para manejar el arrastre de archivos al Chat de la sesión abierta.
        if (files && files.length > 0) {
            // Mapear los archivos y agregarlos a la lista general de archivos seleccionados
            const fileType = handleDropFile(files, filesSelected, setFilesSelected, null, setOpenMessageFileSize);
            setTypeFile(fileType);
        }
    };

    //Custom Hook para importar funciones para el arrastrar y soltar archivos multimedias.
    const { dropAreaRef, isDragging, handleDragOver, handleDragLeave, handleDrop } = useDragAndDrop(onHandleDrop);

    const headerSession_sytle = { boxShadow: ' 0 2px 3px 2px rgba(141, 141, 141, 0.1)' }
    const bodySession_sytle = {
        border: isDragging ? '2px dashed grey' : '',
        height: sessionContainerHeight ? `${sessionContainerHeight.height - sessionContainerHeight.height * 0.12}px` : "698px",
    };

    // Verificar condiciones para renderizar componentes.
    let DRAGGING_VIEW_CONDITION = verifyCondition_draggingView(filesSelected, isDragging);

    /*  let SESSION_HEIGHT_BY_STATUS_CONDITION = verifyCondition_sessionHeight(sessionSelected); //Se usa solo en el caso de que no 
        // se quiera que se puedan enviar mensajes luego de ser finalizada la sesión.  */

    //ocultar y mostrar el botón de mensajes rápidos, y llamar a la función callback en Chat.
    const handleChangeAccordion = (event, isExpanded) => {
        onSelectedSession(session); //Llamar a la función callback para actualizar el id de la sesión abierta.
        if (isExpanded) {
            onSelectedSession(session); //Llamar a la función callback para actualizar el id de la sesión abierta.
            setExpanded(true);
            setSessionExpanded(true);
        } else {
            onSelectedSession({}); //Llamar a la función callback para actualizar el id de la sesión abierta. */
            setExpanded(false);
            setSessionExpanded(false);
        }
    };

    useEffect(() => { setExpanded(true); setSessionExpanded(true) }, [sessionSelected.IdSession]); //Se ejecuta para expandir la sesión en curso del chat seleccionado.
    useEffect(() => { setSessionContainerHeight(containerRefHeight) }, [containerRefHeight]); //Se ejecuta para adaptar el alto del contenedor de la session al alto total segun responsividad.
    return (

        <Accordion expanded={expanded && sessionSelected.IdSession === session.IdSession}
            onChange={handleChangeAccordion} defaultExpanded={session.Fin !== null ? false : true}
            sx={{ boxShadow: '0 2px 3px 2px rgba(141, 141, 141, 0.1)' }}>

            {/*------------Encabezado con fechas y el estado de la sesión-----------------*/}
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={headerSession_sytle}
                className="container-chat__sessions--texts" aria-controls="panel1-content" id="panel1-header">
                <SessionHeader sessionSelected={sessionSelected} session={session}
                    chatData={chatData} sessions={sessions} onSelectedSession={onSelectedSession} />
            </AccordionSummary>

            {/*-----------Contenido de los mensajes-----------------*/}
            <AccordionDetails ref={dropAreaRef} onDragOver={handleDragOver} onDragLeave={handleDragLeave}
                onDrop={handleDrop} className={`container-acordeon-session `}
                style={bodySession_sytle}>
                {/*--Vista cuándo se arrastra un archivo multimedia-- */}
                {DRAGGING_VIEW_CONDITION && <Draggingview />}

                {/*---Renderiza una nueva burbuja con mensaje dependiendo el tipo--*/}
                <MessageInChat chatData={chatData} session={session} sessionSelected={sessionSelected.IdSession} />
            </AccordionDetails>

        </Accordion>
    )
};

export default Session;